function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3547 8.60274C16.6781 4.7096 12.2071 2.99796 8.42653 4.7096C4.64595 6.42124 2.93647 10.9856 4.61307 14.8452C6.28968 18.7048 10.7606 20.45 14.5412 18.7383C18.3547 17.0267 20.0642 12.4623 18.3547 8.60274ZM13.5221 16.4226C10.9908 17.5637 8.03204 16.4226 6.9143 13.8384C5.79656 11.2541 6.9143 8.23357 9.44565 7.09247C11.977 5.95138 14.9357 7.09247 16.0535 9.67671C17.2041 12.2274 16.0535 15.2479 13.5221 16.4226Z",
  fill: "#04BCF8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4837 13.7703C12.5912 13.7703 13.4891 12.8537 13.4891 11.723C13.4891 10.5924 12.5912 9.67578 11.4837 9.67578C10.3762 9.67578 9.47836 10.5924 9.47836 11.723C9.47836 12.8537 10.3762 13.7703 11.4837 13.7703Z",
  fill: "#051132"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.39644 6.85645C2.8047 6.92357 0.174725 7.29275 0.010351 7.86329C-0.154022 8.40028 1.68696 10.2797 2.14721 10.716C2.27871 9.30644 2.70608 7.99754 3.39644 6.85645Z",
  fill: "#051132"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.71677 19.9795C6.78252 20.5836 7.14414 23.2685 7.70301 23.4364C8.229 23.6042 10.07 21.7247 10.4974 21.2548C9.11662 21.1206 7.83451 20.6843 6.71677 19.9795Z",
  fill: "#051132"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20.853 12.7305C20.7215 14.1401 20.2612 15.449 19.6037 16.59C20.1955 16.5229 22.8255 16.1537 22.9898 15.5832C23.1542 15.0462 21.2803 13.1668 20.853 12.7305Z",
  fill: "#051132"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2834 3.46741C16.2176 2.8633 15.856 0.178375 15.2971 0.0105673C14.7712 -0.157241 12.8973 1.72221 12.5028 2.19207C13.8507 2.32632 15.1328 2.76262 16.2834 3.46741Z",
  fill: "#051132"
});

var SvgIconFlybits = function SvgIconFlybits(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFlybits, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_flybits.8abda715.svg";
export { ForwardRef as ReactComponent };